import { FilterHandler } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { PermissionChecker } from '../../../session'
import AddNewButton from '../AddNewButton'
import FullPageTemplate from '../../../../components/templates/FullPageTemplate'
import MMainMenu from '../../../menu/mainMenu/M.MainMenu'
import MPageHeader from '../../../../components/presentation/M.PageHeader'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../../components/helpers/Separator'

const MSAssetsListPage = () => {
  const { t } = useTranslation(['common', 'listAsset'])

  return (
    <FullPageTemplate>
      <PermissionChecker module="place">
        <FilterHandler tempStorageNamespace="assets" initialState={{}}>
          <MPageHeader title={t('listAsset:title')} />
          <PageHeader />
          <PageContent />
        </FilterHandler>
        <Separator />
        <MMainMenu active="asset" />
        <AddNewButton />
      </PermissionChecker>
    </FullPageTemplate>
  )
}

export default MSAssetsListPage
